import { Api } from 'utils';

class ModeratorService {
	
	static get = async (params?: any) => Api.createResponse('client/moderators',params);
	static create = async (params?: any) => Api.createResponse('client/moderators/create',params);
	static delete = async (params?: any) => Api.createResponse('client/moderators/delete',params);

	static admin = {
		get: async (params?: any) => Api.createResponse('admin/moderators',params),
		create: async (params?: any) => Api.createResponse('admin/moderators/create',params),
		delete: async (params?: any) => Api.createResponse('admin/moderators/delete',params),
		getUsers: async (params?: any) => Api.createResponse('admin/moderators/users',params),
	}

}

export default ModeratorService;